import { useState } from "react";
import { useAuth } from "../context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Info, ClipboardList, PlusCircle, CheckCircle2, Bell } from "lucide-react";

const ISTRUZIONI = {
  condomino: [
    { icon: PlusCircle, t: "Segnala una manutenzione", d: "Tocca \"Segnala una manutenzione\", scegli la categoria, descrivi il problema e, se vuoi, allega una foto. Conferma il consenso privacy e invia." },
    { icon: ClipboardList, t: "Segui la tua richiesta", d: "In \"Le mie manutenzioni\" vedi lo stato di ogni richiesta: Nuova, Affidata, In lavorazione, Eseguito, Chiusa." },
    { icon: Bell, t: "Notifiche", d: "La campanella ti avvisa quando lo stato cambia. A lavoro concluso puoi lasciare una valutazione." },
  ],
  fornitore: [
    { icon: ClipboardList, t: "Le richieste affidate", d: "In \"Manutenzioni\" trovi gli incarichi a te affidati con i dettagli e i contatti." },
    { icon: CheckCircle2, t: "Accetta ed esegui", d: "Su una richiesta Affidata premi \"Accetto\" o \"Rifiuto\". A lavoro finito premi \"Incarico eseguito\"." },
    { icon: Bell, t: "Notifiche", d: "Ricevi un avviso a ogni nuovo incarico tramite la campanella in alto." },
  ],
  admin: [
    { icon: ClipboardList, t: "Gestisci le manutenzioni", d: "Dal Cruscotto e da \"Manutenzioni\" affidi le richieste ai fornitori, segui scadenze e chiudi con ricevuta PDF." },
    { icon: PlusCircle, t: "Anagrafiche e accessi", d: "Gestisci Condomìni, Condòmini e Fornitori. Per i condòmini puoi creare gli accessi e inviare le credenziali." },
    { icon: Bell, t: "Alert e report", d: "Ricevi alert su scadenze e report periodici via email. La sezione Scadenze mostra il calendario." },
  ],
};

export function HelpInfo({ variant = "dark" }) {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const items = ISTRUZIONI[user?.role] || ISTRUZIONI.condomino;
  const btnClass = variant === "dark"
    ? "text-slate-300 hover:text-white hover:bg-slate-800"
    : "text-slate-600 hover:text-brand hover:bg-slate-100";

  return (
    <>
      <button data-testid="help-info-button" onClick={() => setOpen(true)} title="Come si usa l'app"
        className={`rounded-lg p-2 transition-colors ${btnClass}`}>
        <Info className="w-6 h-6" />
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="help-info-dialog">
          <DialogHeader>
            <DialogTitle className="text-2xl flex items-center gap-2">
              <Info className="w-6 h-6 text-brand" /> Come si usa l'app
            </DialogTitle>
            <DialogDescription className="text-base text-slate-600">Una guida rapida alle funzioni principali.</DialogDescription>
          </DialogHeader>
          <div className="space-y-4">
            {items.map((it, i) => {
              const Icon = it.icon;
              return (
                <div key={i} className="flex items-start gap-3">
                  <div className="bg-[#FBEEF3] text-brand rounded-lg p-2 shrink-0"><Icon className="w-5 h-5" /></div>
                  <div>
                    <div className="font-bold text-base">{it.t}</div>
                    <div className="text-base text-slate-600 leading-snug">{it.d}</div>
                  </div>
                </div>
              );
            })}
            {(() => {
              const tit = user?.titolare_trattamento;
              const nome = (tit?.ragione_sociale || "").trim();
              const email = (tit?.email || "").trim();
              if (nome && email) {
                return <p className="text-sm text-slate-500 pt-2 border-t">Per assistenza contatta <b>{nome}</b> — <a href={`mailto:${email}`} className="text-brand underline">{email}</a>.</p>;
              }
              if (nome) {
                return <p className="text-sm text-slate-500 pt-2 border-t">Per assistenza contatta <b>{nome}</b>.</p>;
              }
              return <p className="text-sm text-slate-500 pt-2 border-t">Per assistenza contatta lo Studio di amministrazione che ha rilasciato le Sue credenziali.</p>;
            })()}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
